function accountNav() {
  jQuery(document).ready(function() {
    jQuery('body.woocommerce-account .nav-tab-wrapper a:last-child').attr('target','_blank');
  });
}

accountNav();